var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.981,
    height: 21.5,
    viewBox: "0 0 21.981 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49804",
    "data-name": "Group 49804",
    transform: "translate(-4226 197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93677",
    "data-name": "Path 93677",
    d: "M3.811,17.587A3.061,3.061,0,0,1,.75,14.526V3.811A3.06,3.06,0,0,1,3.811.75H14.526a3.061,3.061,0,0,1,3.061,3.061",
    transform: "translate(4226 -197)",
    fill: "none",
    stroke: "#ee4758",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138327",
    "data-name": "Rectangle 138327",
    width: 16.632,
    height: 16.633,
    rx: 3.024,
    transform: "translate(4230.599 -192.883)",
    fill: "none",
    stroke: "#ee4758",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyicon);
export default __webpack_public_path__ + "static/media/copyicon.fb251608a217d29240322631ea09541d.svg";
export { ForwardRef as ReactComponent };